// extracted by mini-css-extract-plugin
module.exports = {"authenticationPageWrapper":"Authentication_authenticationPageWrapper__taLlx","leftSide":"Authentication_leftSide__ltesA","rightSide":"Authentication_rightSide__8GxTo"};